<template>
  <tr
    v-if="bluredOrNotHidden"
    :class="{ active: isActive, hovered: showActions }"
    class="draggableBlock"
    data-block="Raw"
    @mouseover="mouseOver"
    @mouseleave="mouseOut"
    @click.stop="onClick"
  >
    <td
      :id="id"
      style="word-break: break-word; font-size: 0px"
      :class="{
        'block-borders': showDragBorder,
        'dragged-opacity': isCurrentElementDragged,
      }"
    >
      <blockActions
        v-if="showActions"
        :is-html="true"
        :column-padding-x="columnPaddingX"
        :column-width="columnWidth"
        :disable-up-movement="disableUpMovement"
        :disable-down-movement="disableDownMovement"
        :block-height="blockHeight"
        :block-width="blockWidth"
        :is-active="isActive"
        :is-last-column="isLastColumn"
        :section-index="sectionIndex"
        :column-index="columnIndex"
        :block-index="blockIndex"
        :show-paste="showPaste"
        :copied="copied"
        @duplicate="copyBlock"
        @remove="deleteBlock"
        @moveUp="moveUp"
        @moveDown="moveDown"
        @copy="copyToClipboard"
      ></blockActions>
      <div
        style="min-height: 20px; font-size: 0px"
        :style="hiddenStyle"
        v-html="content"
      ></div>
    </td>
  </tr>
</template>

<script lang="ts" setup>
  import blockProperties from "@/composables/useBlockProperties";
  import blockActions from "./blockActions.vue";
  import { TopolRawBlock } from "@/schemas/template/blocks/rawBlockSchema";
  import { useMjmlStore } from "@/stores/mjmlStore";

  import { nextTick, computed } from "vue";

  const props = defineProps<{
    block: TopolRawBlock;
    columnIndex: number;
    sectionIndex: number;
    blockIndex: number;
    isLocked: boolean;
  }>();

  const {
    showActions,
    showPaste,
    blockHeight,
    blockWidth,
    id,
    bluredOrNotHidden,
    hiddenStyle,
    isActive,
    disableUpMovement,
    disableDownMovement,
    columnPaddingX,
    columnWidth,
    isCurrentElementDragged,
    showDragBorder,
    isLastColumn,
    copied,
    mouseOver,
    mouseOut,
    click,
    copyBlock,
    deleteBlock,
    moveUp,
    moveDown,
    copyToClipboard,
  } = blockProperties(props);

  const mjmlStore = useMjmlStore();

  const content = computed(() => {
    return mjmlStore.getSpecificBlockContent(props.block);
  });

  async function onClick() {
    click();

    await nextTick(() => {
      const editor = document.querySelector("#html-editor");

      if (!editor) return;

      const textarea = editor.querySelector(
        ".ace_text-input"
      ) as HTMLTextAreaElement;

      if (textarea) {
        textarea.focus();
      }
    });
  }
</script>
